import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DateTimeField from '../bootstrap-datetimepicker';

/**
 * @todo
 * This component is of poor quality and uses deprecated features and
 * dead 3rd-party code.
 * Future improvement work should refactor this to improve the quality of the
 * codebase.
 */
class SavingPotDatePicker extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
    this.onClose = this.onClose.bind(this);

    this.state = {
      dateTime: props.dateTime,
    };
  }

  componentDidMount() {
    ReactDOM.findDOMNode(
      this.refs.sdatePicker
    ).children[2].children[0].disabled = true;
    ReactDOM.findDOMNode(this.refs.sdatePicker).children[2].addEventListener(
      'click',
      this.onClick
    );
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ dateTime: nextProps.dateTime });
  }

  onClick() {
    setTimeout(() => {
      ReactDOM.findDOMNode(this.refs.sdatePicker).children[0].addEventListener(
        'click',
        this.onClose
      );
    }, 100);
  }

  onClose() {
    this.setState({ dateTime: moment(this.props.dateTime) });
  }

  render() {
    return (
      <DateTimeField
        ref="sdatePicker"
        minDate={this.props.minDate}
        dateTime={this.state.dateTime}
        format={this.props.format}
        viewMode={this.props.viewMode}
        inputFormat={this.props.inputFormat}
        onChange={this.props.onChange}
        defaultText={this.props.defaultText}
      />
    );
  }
}

SavingPotDatePicker.propTypes = {
  minDate: PropTypes.object,
  dateTime: PropTypes.any.isRequired,
  format: PropTypes.string,
  viewMode: PropTypes.string,
  inputFormat: PropTypes.string,
  onChange: PropTypes.func,
  defaultText: PropTypes.string,
};

export { SavingPotDatePicker };
